"use client";
import { useTheme } from "next-themes";
import { useEffect } from "react";
import { useDoctorData } from "@/hooks/useDoctorData";
import { getStoredDoctorTheme, persistDoctorTheme, resolveDoctorTheme, } from "@/lib/doctor-theme";
import { withoutThemeTransitions } from "@/lib/theme-transition";
/** Keeps next-themes, DOM class, and storage aligned across all routes. */
export function DoctorThemeSync() {
    const { data: doctorData } = useDoctorData();
    const { setTheme } = useTheme();
    useEffect(() => {
        const theme = resolveDoctorTheme(getStoredDoctorTheme(), doctorData === null || doctorData === void 0 ? void 0 : doctorData.theme);
        if (!theme)
            return;
        withoutThemeTransitions(() => {
            setTheme(theme);
            persistDoctorTheme(theme);
        });
    }, [doctorData === null || doctorData === void 0 ? void 0 : doctorData.theme, setTheme]);
    return null;
}
